/**
 * O nome de uma referência do evento com a preposição na frente, contraída
 * como se fala: "A oportunidade do evento" vira "Na oportunidade do evento" ou
 * "Pela oportunidade do evento"; "O novo responsável", "No"/"Pelo"; "Quem
 * atende", "Em quem"/"Por quem".
 */

const CONTRACOES: Record<'em' | 'por', Record<string, string>> = {
  em: { A: 'Na', O: 'No', As: 'Nas', Os: 'Nos' },
  por: { A: 'Pela', O: 'Pelo', As: 'Pelas', Os: 'Pelos' },
};

export function comPreposicao(preposicao: 'em' | 'por', titulo: string): string {
  const [primeira, ...resto] = titulo.split(' ');
  const contraida = CONTRACOES[preposicao][primeira ?? ''];
  if (contraida) return [contraida, ...resto].join(' ');
  const inicio = preposicao === 'em' ? 'Em' : 'Por';
  return `${inicio} ${titulo.charAt(0).toLowerCase()}${titulo.slice(1)}`;
}
